import React, { useEffect, useState } from "react";
import { Firestore, Auth } from "../config/firebase";

const UpvoteView = props => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    Firestore.collection("upvotes")
      .doc(props.postID)
      .onSnapshot(doc => {
        if (!doc.exists) {
          setCount(0);
        } else {
          setCount(doc.data().upvote_count);
        }
      });
  });
  return <div>{count}</div>;
};

export default UpvoteView;
